import React from 'react';
import styled from 'styled-components';

const ShareActionButton = ({
  onClick,
  icon,
  text,
  secondary = false,
  ...props
}) => {
  return (
    <StyledButton onClick={onClick} secondary={secondary} {...props}>
      {icon && (
        <img
          src={icon}
          alt="Action Icon"
          width={18}
          height={18}
          style={{ marginRight: '8px' }}
        />
      )}
      {text}
    </StyledButton>
  );
};

export default ShareActionButton;

const StyledButton = styled.button`
  width: 100%;
  min-height: 40px;
  padding: 10px 16px;
  background-color: ${(props) => (props.secondary ? '#BA2F25' : '#7200E0')};
  color: white;
  border: ${(props) => (props.secondary ? '1px solid #C62828' : 'none')};
  border-radius: ${({ $bulkDownload }) => ($bulkDownload ? '999px' : '8px')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 500;
  font-size: ${({ $bulkDownload }) => ($bulkDownload ? '16px' : '14px')};
  margin-top: 12px;

  &:disabled {
    background-color: #c9c6cc;
    border-color: #c9c6cc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: ${(props) => (props.secondary ? '#a72821' : 'rgba(80, 0, 157, 1)')};
  }
`;
